import React, { useContext, useState } from 'react';
import {
  Autocomplete,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  TextField
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { setGlobalError } from '../../../Redux/Reducer/GlobalError';
import { VIEW_TYPES } from '../utils';
import { getCommunities } from '../../../Redux/util/Apis/communities';
import { GlobalContext } from '../../../utils/ContextProviders/GlobalContextProvider';
import { useChatbotSettingsContext } from '../../../utils/ContextProviders/ChatbotSettingsContextProvider';

const CommunitiesList = () => {
  const { setView } = useChatbotSettingsContext();
  const dispatch = useDispatch();
  const { userData } = useContext(GlobalContext);
  const tenantsByUser = userData?.clients;
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [communities, setCommunities] = useState([]);
  const [selectedItem, setSelectedItem] = useState('preset');

  const getCommunitiesByClients = async tenantId => {
    const res = await getCommunities(tenantId);
    if (res?.error) {
      dispatch(setGlobalError('Failed to fetch communities.'));
      console.error('Communities fetch error:', res);
      return;
    }
    const items = Array.isArray(res) ? res : res?.data || [];
    setCommunities(items.map(c => ({ _id: c.id, name: c.name })));
  };

  // Handle tenant selection
  const handleTenantChange = (event, newValue) => {
    const tenantId = newValue?._id || null;
    setSelectedTenant(tenantId);
    if (tenantId) {
      getCommunitiesByClients(tenantId);
    } else {
      setCommunities([]);
    }
  };

  // Handle menu item click
  const handleItemClick = key => {
    setSelectedItem(key);

    if (key === 'preset') {
      setView({ view: VIEW_TYPES.PRESET_CHATBOT_SETTINGS });
    } else {
      const selectedCommunity = communities.find(
        community => community._id === key
      );
      if (selectedCommunity) {
        setView({
          view: VIEW_TYPES.COMMUNITY_CHATBOT_SETTINGS,
          communityId: selectedCommunity._id,
          tenantId: selectedTenant,
          communityName: selectedCommunity.name
        });
      }
    }
  };

  return (
    <div style={{ width: 256 }}>
      {/* Tenant Dropdown */}
      <Autocomplete
        options={tenantsByUser || []}
        getOptionLabel={option => option.name || ''}
        value={tenantsByUser?.find(t => t._id === selectedTenant) || null}
        onChange={handleTenantChange}
        renderInput={params => (
          <TextField {...params} placeholder="Select Clients..." />
        )}
        sx={{ mb: 1 }}
      />

      <List component="nav" dense>
        <ListSubheader>Preset</ListSubheader>
        <ListItemButton
          selected={selectedItem === 'preset'}
          onClick={() => handleItemClick('preset')}
        >
          <ListItemText primary="Preset Chatbot" />
        </ListItemButton>

        <ListSubheader>Communities</ListSubheader>
        <div style={{ height: 'calc(100vh - 380px)', overflowY: 'auto' }}>
          {communities.map(community => (
            <ListItemButton
              key={community._id}
              selected={selectedItem === community._id}
              onClick={() => handleItemClick(community._id)}
            >
              <ListItemText primary={community.name} />
            </ListItemButton>
          ))}
        </div>
      </List>
    </div>
  );
};

export default CommunitiesList;
